import { gql } from '@apollo/client';
// local imports
import { API_JOB_CATEGORIES } from '../config/api';

export const JOB_CATEGORIES_QUERY = gql`
  query JobCategories(
    $limit: Int
  ) {
    jobCategories(
      limit: $limit
    )
    @rest(
      type: "LookupPayload",
      path: "${API_JOB_CATEGORIES}?{args}"
    ) {
      count
      results {
        id
        title
      }
    }
  }
`;
